<template>
    <div id="meal-plans-manager">
        <v-card ref="mealPlansManager">
            <v-card-title>
                Meal Plans Manager
                <v-spacer></v-spacer>
                <meal-plan-add v-if="getAccess()" @refreshData="refreshData" @setNotification="setNotification">
                </meal-plan-add>
            </v-card-title>
            <v-card-text>
                <v-data-table :headers="headers" :items="data" sort-by="mealPlan">
                    <template v-if="getAccess()" v-slot:item.actions="{ item }">
                        <meal-plan-edit :item="item" @refreshData="refreshData" @setNotification="setNotification">
                        </meal-plan-edit>
                        <meal-plan-delete :item="item" @refreshData="refreshData" @setNotification="setNotification">
                        </meal-plan-delete>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import MealPlanAdd from './AddMealPlan';
import MealPlanDelete from './DeleteMealPlan';
import MealPlanEdit from './EditMealPlan';

export default {
    name: 'meal-plans-manager',
    components: {
        MealPlanAdd,
        MealPlanDelete,
        MealPlanEdit
    },
    props: {
        data: {
            required: true,
            type: Array
        },
        permission: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            headers: [{
                    align: 'start',
                    text: 'Meal Plan',
                    value: 'mealPlan'
                },
                {
                    text: 'Created Date',
                    value: 'datecode',
                },
                {
                    text: 'Created By',
                    value: 'createdByUsername',
                },
                {
                    sortable: false,
                    text: 'Actions',
                    value: 'actions'
                }
            ]
        }
    },
    methods: {
        getAccess() {
            if (this.permission.enabled == "1" && this.permission.access == "write") {
                return true;
            }

            return false;
        },
        refreshData() {
            this.$emit('refreshData');
        },
        setNotification(color, icon, message, status) {
            this.$emit('setNotification', color, icon, message, status);
        }
    }
}
</script>